import { render, staticRenderFns } from "./PhoneConfirmationForm.vue?vue&type=template&id=34b90bc8&"
import script from "./PhoneConfirmationForm.vue?vue&type=script&lang=js&"
export * from "./PhoneConfirmationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports